import React, { useCallback } from 'react';
import { StyledLeadContainer, StyledConfigurationContainer, StyledIndexContainerDiv } from '../../../Components/Styled';
import TextFiledWithLabel from '../../../Components/TextFieldWithLabel';
import { Box, Autocomplete,Typography, Stack } from '@mui/material';
import { GridRowModes } from '@mui/x-data-grid';
import { useState } from 'react';
import DataGridTable from '../../../Components/DataGrid';
import CreateEditUser from './CreateEditUser';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { requestGetUserList } from '../../../Store/User/action';
import BiztantuLoader from '../../../Components/Loader';
import LeadDialog from '../../../Components/LeadDialog';
import { requestGetAllRoles } from '../../../Store/Function/action';
import { createRequestData, getRequestData, isValidEmail } from '../../../Utility/apiHelper';
import { useSnackbar } from 'notistack';
import { ACTIVE_STATUS, emailWidth, fullNameWidth, handleValidateCodevalue, nameWidth, phoneWidth, productIdWidth, searchEntity, statusWidth } from '../../../Utility/constant';
import axiosInstance from '../../../api/axiosInstance';
import SelectBoxWithLabel from '../../../Components/SelectBoxWithLable';
import AutoCompleteComponent from '../../../Components/AutoCompleteComponenet';
import NumericTextField from '../../../Components/NumericTextfield';
import CommonEmail from '../../../Components/CommonEmail';
import BiztantuSearch from '../../../Components/BiztantuSearch';
import { handleCreateEditConfiguration } from '../../../Store/Global/action';
import SendNotification from '../../../Components/SendNotification';
import { resetState } from '../../../Utility/resetSearchFunction';
import { resetSearch, setPreserveSearch, setSearch } from '../../../Store/SearchReducer/action';
import { useEntitySearch } from '../../../Utility/hooks/useEntitySearch';
const User = ({isUserScreen = true}) => {
  
    const [isLoading, setIsLoading] = useState(false);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const formValues = useSelector((state) => state?.search?.user) || {};
    
    const preserveSearch = useSelector(
        state => state?.search?.preserveSearch?.[searchEntity?.user]
    );
    const isReady = !!currentUser?.client;
       useEntitySearch({
           entity: searchEntity?.user,
           getInitialState : ()=> ({selectedCompany : currentUser?.client}),
           searchState: formValues,
           isReady,
           preserveSearch,
           fetchAction: (params) =>
               requestGetUserList(
                   params,
               ),
       });

    const [datagriddata, setdatagriddata] = useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [iscreateuser, setCreateuser] = useState(false);
    const [isEdituser, setEdituser] = useState(false);
    const [currentuserid, setcurrentuserid] = useState("");
    const isLoadingProgress = useSelector(state => state?.global.isLoading);
    const dispatch = useDispatch();
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [assignRoleDetails, setassignroledetails] = useState({
      isOpen: false
    });
    const [isViewMode , setIsViewMode] = useState(false)
    useEffect(() => {
        dispatch(requestGetAllRoles());
    },[currentUser])
    const {enqueueSnackbar} = useSnackbar();
  
    const[selectedRoles, setSelectedRoles] = useState([]);
    const allrolesData = useSelector(state => state?.permission?.allRoleTypes);
    const [ownerlistdropdown, setownerlistdropdown] = useState([]);
    const userStatusData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == 'USER_STATUS')?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const userData = useSelector(state => state?.owner?.userList);
    
    const getManagers =async()=>{
            const url = `${process.env.REACT_APP_BASE_URL}users/clientId/${formValues?.selectedCompany?.id}`;
            const response = await getRequestData(url);
            const filteredOwners = response?.data;
                const ownerlistdata = filteredOwners?.map(item => (
                    {label: `${item?.firstName} ${item?.lastName}`,
                    value: item?.id,
                }));
            setownerlistdropdown(ownerlistdata);
        }
    
        useEffect(() => {
            if (!formValues?.selectedCompany) return;
           getManagers();
        },[formValues?.selectedCompany])

    const getAllUserListData = useCallback(() => {
    const queryparams = {
        params: {
          clientId : currentUser?.client?.id,
        }
    };
    dispatch(requestGetUserList(queryparams));
}, [isUserScreen, formValues, dispatch]);


  useEffect(()=>{
    const mappedUserData = (userData || [])?.map((item)=>{
      return{
      ...item,
  }})
    setdatagriddata(mappedUserData)
    
  },[userData])




    const handleOnChange = (event) => {
      dispatch(setSearch(searchEntity?.user, {
            ...formValues,
            [event.target.name]: event.target.value,
          }));
    }

    const handleSaveClick = (id) => {
    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    }

    const handleEditClick = (id) => {
          setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    }

    const handleEditApplication = (id,value) => {
        setEdituser(true);
        dispatch(setPreserveSearch(searchEntity?.user,true));
        setCreateuser(false);
        setcurrentuserid(id);
        setIsViewMode(value);
        dispatch(handleCreateEditConfiguration(true));
    }

    const handleCancelClick = (id) => {
    setRowModesModel({
    ...rowModesModel,
    [id]: { mode: GridRowModes.View, ignoreModifications: true },
    });
  }

    const columns = [
      { 
        field: 'id', 
        headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_ID'),
        flex: 1,
        minWidth : productIdWidth,
        editable : false,
        renderCell: (params) => (
         isUserScreen ? <a 
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handleEditApplication(params.row.id,true);
            }}
            style={{ color: 'var(--primary-color)', textDecoration: 'underline', cursor: 'pointer' }}
          >
            {params.row.id}
          </a>
          :     
      <span>
        {params.row.id}
      </span>
        )
      },
        { 
          field: 'firstName', 
          headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_FIRSTNAME'),
          flex: 1,
          minWidth : nameWidth,
          editable: true ,
        },
        {
            field: 'lastName',
            headerName:handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_LASTNAME'),
            flex: 1,
            minWidth : nameWidth,
            editable: true,
        },
        {
          field: 'userEmail',
          headerName: handleValidateCodevalue(internationalise,'COMMON_EMAIL_ID'),
          flex: 1,
          minWidth : emailWidth,
          editable: false,
        },
          {
            field: 'status',
            headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_STATUS'),
            flex: 1,
            minWidth : statusWidth,
            editable: false,
              valueGetter:({value})=>{
                if(!value){
                  return ""
                }
                return handleValidateCodevalue(internationalise,value)
              }
        },
        {
          field: 'mobile',
          headerName: handleValidateCodevalue(internationalise,'COMMON_PHONE_NUMBER'),
          flex: 1,
          minWidth : phoneWidth,
          editable: false,
        },
        { 
          field: 'companyName', 
          headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_CLIENT'),
          flex: 1,
          minWidth : nameWidth,
          editable: false ,
        },
  
          {
            field: 'managerName',
            headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_RM'),
            flex: 1,
            minWidth : fullNameWidth,
            editable: false,
            
        },
        {
          field: 'department',
          headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_DEPT'),
          flex: 1,
          minWidth : nameWidth,
          editable: false,
        },
        {
          field: 'function',
          headerName: handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_FUNC'),
          flex: 1,
          minWidth : nameWidth,
          editable: false,
        },
      ];

    const handleSearch = async () => {
                  setIsLoading(true);
                  // const hasValidParams = Object.values(formValues).some(
                  // value => value !== undefined && value !== null && String(value).trim() !== ''
                  // );
                  // if (!hasValidParams) {
                  // setIsLoading(false)
                  // setdatagriddata([])
                  // enqueueSnackbar(handleValidateCodevalue(internationalise,'ENTER_AT_LEAST_ONE_SEARCH_FIELD'), {variant: 'warning'});
                  // return;
                  // }
                  const {selectedCompany,...restValues} = formValues
                  const queryparams = {
                    params: {
                      ...restValues,
                      clientId : selectedCompany?.id
                    },
                  };
                  dispatch(requestGetUserList(queryparams))
                  setdatagriddata([])
                  setIsLoading(false)
}


    const handleResetSearch = () => {
    dispatch(
      resetSearch(searchEntity?.user,
        resetState(formValues, {
          selectedCompany: currentUser?.client,
        })
      )
    );
};


    const handleCreateuser = () => {
        setCreateuser(true);
        dispatch(handleCreateEditConfiguration(true));
    }
    
    const handlebackbutton = () => {
        setEdituser(false);
        setCreateuser(false);
        dispatch(handleCreateEditConfiguration(false));
        handleSearch()
    }

    const handleAssignRoles = () => {
      setassignroledetails({
        ...assignRoleDetails,
        isOpen: true
      })
    }

    const handleCloseAssignModal = () => {
      setassignroledetails({
        ...assignRoleDetails,
        isOpen: false
      });
      setSelectedRoles([]);
    }

    const handleSaveAssignRoles = async() => {
      if(selectedRoles.length > 0) {
        const roleIds =  selectedRoles?.map(item => item?.id);
        const reqBody = {
          "roleIds": roleIds,
          "userId": selectionModel[0]
        }

        const url = `${process.env.REACT_APP_BASE_URL}user-role`;

        const responseData = await createRequestData(reqBody, url);
       

        if(responseData?.status == 200) {
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_ADDED_SUCCESSFULLY ') , {variant: "success"});
        } else {
          enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
        }
      }
    }
       const handleUpdateUser = (rowRecord) => {
        if(!isValidEmail(rowRecord?.userEmail)){
              enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_MSG_VALID_EMAIL"),{variant:'error'});
              return;
              }
          setIsLoading(true)
          const Id = rowRecord?.id;
      
          const { id, updated, ...UpdatedUserData} = rowRecord;
          
          const payload = {
              ...UpdatedUserData,
          }
          axiosInstance.put(`${process.env.REACT_APP_BASE_URL}users/${Id}`, payload).then(response => {
              enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_UPDATED_SUCCESSFULLY '), {variant: 'success'});
              
          }).catch(error => {
            if(error?.response?.status !== 401) {
              enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_PLEASE_TRY_AGAIN"), {variant: 'error'})
            }
          }).finally(() => {
            setIsLoading(false);
          });}

    const handleSelectMultiRoles = (event, roles, reason) => {
        setSelectedRoles(roles)
    }
    const processRowUpdate = (newRow, oldRow) => {
            if(JSON.stringify(newRow) == JSON.stringify(oldRow)) {
              enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_NO_DATA_CHANGED'), {variant: 'info'});
            } else {
              handleUpdateUser(newRow); 
            }
        const updatedRow = { ...newRow, isNew: false };
        setdatagriddata(datagriddata.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
      ;
    }
    

       const handleNotifyUserFromLeadPage = async(User, selectedLead) => {
          const selectedDetails = User?.filter((item) =>selectedLead?.includes(item?.id))
                setIsOpenNotificationDialog({
                  ...isOpenNotificationDialog,
                  selectedDetails : selectedDetails,
                  isOpen : true,
              });
          }
          
          const [isOpenNotificationDialog,setIsOpenNotificationDialog] = useState({
                isOpen : false,
                selectedDetails : []
          })


    return (

        <BiztantuLoader isChildren={true} open={isLoadingProgress}>
           {(!iscreateuser && !isEdituser) ? <Box sx={{marginBottom: 0,
                // '& .MuiTextField-root': { m: 1, width: '29ch', marginTop: 3 },
                }}>
                  {isUserScreen &&
              <StyledConfigurationContainer>
                <Typography variant='h6'>
                  {handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_TITLE')}
                </Typography>
              </StyledConfigurationContainer>
              }
              <StyledIndexContainerDiv>
                {isUserScreen &&
                <StyledLeadContainer sx={{backgroundColor: "#F4F9FE"}}>
                  <Stack className='table-header-search table-header-search-common'>
                        <BiztantuSearch
                        showDates = {false}
                        showStatus = {false}
                        entityDetails={formValues}
                        handleSearch={handleSearch}
                        handleReset={handleResetSearch}
                        >
                    <Box sx={{
                            '& .MuiTextField-root': { m: 1, width: '25ch', marginTop: 2 },
                            }}>                 
                <StyledLeadContainer>
                    <TextFiledWithLabel
                        type="number"
                        name="id"
                        value= {formValues?.id}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_ID')}
                        handleOnChange={handleOnChange}
                    />
                    
                  <AutoCompleteComponent
                  optionSet = {[currentUser?.client]}
                  value={formValues?.selectedCompany || null}
                  name = "clientId"
                  disabled
                  label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_CLIENT')}         
                  />
                  
                    <SelectBoxWithLabel
                        ownerdropdown = {false}
                        id="status"
                        name="status"
                        isStatic = {false}
                        value={formValues?.status||""}
                        optionMenuItem={userStatusData}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_STATUS')}
                        handleOnChange={handleOnChange}
                    />
                <TextFiledWithLabel
                sx = {{visibility : "hidden"}}
                />
                  </StyledLeadContainer>       
                <StyledLeadContainer>
                    <TextFiledWithLabel
                        name="firstName"
                        value= {formValues?.firstName}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_FIRSTNAME')}
                        handleOnChange={handleOnChange}
                    />
                    <TextFiledWithLabel
                        name="lastName"
                        value= {formValues?.lastName}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_LASTNAME')}
                        handleOnChange={handleOnChange}
                    />
                    <NumericTextField
                        name = 'phone'
                        value={formValues?.phone}
                        handleOnChange={handleOnChange}
                        />
                        
                      <CommonEmail 
                      name = 'email'
                      value={formValues?.email}
                      handleOnChange={handleOnChange}
                      />
                </StyledLeadContainer>
                <StyledLeadContainer>
                    <SelectBoxWithLabel
                        name= "managerId"
                        value= {formValues?.managerId}
                        // optionMenuItem ={[{label: "Owner1"}, {label: "Owner2"}]}
                        optionMenuItem = {ownerlistdropdown}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_RM')}
                        handleOnChange={handleOnChange}
                    />
                   <TextFiledWithLabel
                        name="department"
                        value= {formValues?.department}
                        label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_DEPT')}
                        handleOnChange={handleOnChange}
                    />
                    <TextFiledWithLabel
                    name="function"
                    value= {formValues?.function}
                    label={handleValidateCodevalue(internationalise,'CONF_USER_SEARCH_FUNC')}
                    handleOnChange={handleOnChange}
                />
                <TextFiledWithLabel
                sx = {{visibility : "hidden"}}
                />
                 </StyledLeadContainer>
                </Box> 
                        </BiztantuSearch>
                    </Stack>
                    <Stack className='secondry-btn-container' flex={1} padding="10px" justifyContent="flex-end" spacing={2} direction="row">  
                    </Stack>
                </StyledLeadContainer>
            }
                <DataGridTable
                    isCheckboxReq= {false}
                    dataGridData={datagriddata}
                    isLoading={isLoading}
                    height={"calc(100vh - 273px)"}
                    columns={columns}
                    rowModesModel={rowModesModel}
                    isRequiredToolBar = {true}
                    isUserScreen = {isUserScreen}
                    gridType='accountuser'
                    selectionModel={selectionModel}
                    setSelectionModel={(data) => setSelectionModel(data)}
                    handleProcessRowUpdate={processRowUpdate}
                    handleUpdateProduct={handleUpdateUser}
                    handleNotifyUser = {() => handleNotifyUserFromLeadPage(datagriddata, selectionModel)}
                    // handleUpdateProduct={handleUpdateProduct}
                />
              </StyledIndexContainerDiv>
            </Box> : 
                <CreateEditUser
                    setIsViewMode = {setIsViewMode}
                    isViewMode = {isViewMode}
                    handleResetSearch = {handleResetSearch}
                    isEdituser = {isEdituser} 
                    currentuserid={currentuserid}
                    handleCustomBackbutton = {handlebackbutton}
                    allrolesData = {allrolesData}
                    iscreateuser = {iscreateuser}
                    optionSet = {[currentUser?.client]}
                    handleEditApplication={handleEditApplication}
                />

            }
            
      {
        (isOpenNotificationDialog?.isOpen) && (
          <SendNotification
            open={isOpenNotificationDialog?.isOpen}
            title= {handleValidateCodevalue(internationalise,"COMMON_NOTIFY_USER")}
            selectedDetails={isOpenNotificationDialog?.selectedDetails}
            setIsOpenNotificationDialog = {setIsOpenNotificationDialog}
            type = {"User"}
          />
        )
      }

              {
                (assignRoleDetails?.isOpen) && (
                    <LeadDialog 
                        open = {assignRoleDetails?.isOpen}
                        handleClose = {handleCloseAssignModal}
                        title= "Assign Roles"
                        size="sm"
                        selectedowner={true}
                        btnlabel="Save"
                        handleSave={handleSaveAssignRoles}
                    >
                      <Autocomplete
                        multiple
                        options={allrolesData}
                        sx={{width: true ? '50ch !important' : "65ch !important", padding: "7px", display: 'flex'}}
                        getOptionLabel={(option) => option?.name}
                        value={selectedRoles}
                        filterSelectedOptions = {true}
                        disableCloseOnSelect
                        limitTags={2}
                        onChange={handleSelectMultiRoles}
                        renderInput={(params) => (
                        <TextFiledWithLabel
                            {...params}
                            // error={selectedRoles?.length > 0 ? false : requiredValue?.permission}
                            required
                            label="Select Roles"
                            sx={{width: true ? '100% !important' : "65ch !important" , padding: "7px" }}
                            InputLabelProps={{
                            shrink: true,
                        }}
                        />
                        )}
                      />     
                    </LeadDialog>
                )
            }
        </BiztantuLoader>
    )
}

export default User;